/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyQuestionModel } from '../../models/client-survey-question-model';
import { UpdateSurveyQuestionRequest } from '../../models/update-survey-question-request';

export interface UpdateSurveyQuestion$Plain$Params {

/**
 * id of surveyquestion to udpate filter
 */
  surveyQuestionId: number;
  
    /**
     * properties of surveyquestion to update
     */
    body?: UpdateSurveyQuestionRequest
}

export function updateSurveyQuestion$Plain(http: HttpClient, rootUrl: string, params: UpdateSurveyQuestion$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyQuestionModel>> {
  const rb = new RequestBuilder(rootUrl, updateSurveyQuestion$Plain.PATH, 'put');
  if (params) {
    rb.path('surveyQuestionId', params.surveyQuestionId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyQuestionModel>;
    })
  );
}

updateSurveyQuestion$Plain.PATH = '/api/SurveyQuestion/{surveyQuestionId}';
